interface IRange {
  start: number;
  end: number;
}

export function scaleValue (value: number, fromRange: IRange, toRange: IRange): number {
  if ((value < fromRange.start) || (value > fromRange.end)) {
    throw new Error(`${value} must be inside ${fromRange.start} - ${fromRange.end}`);
  }
  const scale = (toRange.end - toRange.start) / (fromRange.end - fromRange.start);
  const cap = Math.min(fromRange.end, Math.max(fromRange.start, value)) - fromRange.start;
  return Math.floor(cap * scale + toRange.start);
}
